import { useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Hero from '../../components/Hero/Hero';
import Home from '../../components/Home/Home';
import classes from './Landing.module.css';
import googleAnalytics from '../../utils/googleAnalytics';

const Landing = () => {
  const location = useLocation();
  const homeRef = useRef();
  const landingRef = useRef();
  const hub = useSelector((state) => state.hub.hub);

  useEffect(() => {
    googleAnalytics({
      event: 'page_view',
      page_title: 'Home',
      section_title: hub.name,
    });
  }, [hub]);

  useEffect(() => {
    const identifier = setTimeout(() => {
      if (location.pathname === '/') {
        if (location.hash === '#home') {
          homeRef.current.scrollIntoView({ behavior: 'smooth' });
        } else {
          landingRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }, 300);
    return () => clearTimeout(identifier);
  }, [location.pathname, location.hash]);

  return (
    <>
      <section ref={landingRef} className={classes.container}>
        <Hero />
      </section>
      <section
        id="home"
        ref={homeRef}
        className={`${classes.container} ${classes.home}`}
      >
        <Home />
      </section>
    </>
  );
};

export default Landing;
